import { cx } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/cx.ts";
import { type ReactNode, useEffect, useRef } from "react";
import { useTranslation } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/react-i18next@17.1.8_i18next@26.5.10_typescript@6.0.3__react-dom@18.3.1_react@18.3.1__react@18.3.1_typescript@6.0.3/node_modules/react-i18next/dist/es/useTranslation.js";

/** FE-01 FR-FE01-07: "<Screen> · SOS Sitios", translated. */
export function useDocumentTitle(screen: string) {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = screen ? t("app.documentTitle", { screen }) : t("app.name");
  }, [screen, t]);
}

export interface PageHeadingProps {
  children: ReactNode;
  /** Sets the document title too (pass the plain screen name). */
  title?: string;
  /** Move focus here on mount (route change, NFR-FE01-05). */
  focusOnMount?: boolean;
  className?: string;
}

/** The page's h1: receives focus after navigation so screen readers announce the new screen. */
export function PageHeading({ children, title, focusOnMount = true, className }: PageHeadingProps) {
  const ref = useRef<HTMLHeadingElement>(null);
  useDocumentTitle(title ?? "");
  useEffect(() => {
    if (focusOnMount) ref.current?.focus({ preventScroll: true });
  }, [focusOnMount]);
  return (
    <h1 ref={ref} tabIndex={-1} className={cx("outline-none", className)}>
      {children}
    </h1>
  );
}
